import TabProperty from './TabProperty';

export default TabProperty;
